import { render, staticRenderFns } from "./sales-order-status-tag.vue?vue&type=template&id=bc998392&scoped=true&"
import script from "./sales-order-status-tag.vue?vue&type=script&lang=js&"
export * from "./sales-order-status-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc998392",
  null
  
)

export default component.exports